import React from 'react';
import { motion } from 'framer-motion';

const StatCard = ({ title, value, icon: Icon, trend, gradient = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`relative overflow-hidden rounded-2xl border p-6 ${
        gradient
          ? 'bg-gradient-to-br from-indigo-500/20 via-purple-500/10 to-transparent border-indigo-500/30'
          : 'bg-white/5 border-white/10'
      } backdrop-blur-xl hover:bg-white/10 transition-colors group`}
      data-testid={`stat-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground font-medium uppercase tracking-wider">
            {title}
          </p>
          <p className="mt-2 text-3xl md:text-4xl font-mono font-bold tracking-tight">
            {value}
          </p>
          {trend && (
            <p className={`mt-2 text-sm ${
              trend.startsWith('+') ? 'text-green-400' : 'text-red-400'
            }`}>
              {trend}
            </p>
          )}
        </div>
        {Icon && (
          <div className="p-3 bg-white/5 rounded-xl group-hover:bg-white/10 transition-colors">
            <Icon className="w-6 h-6 text-indigo-400" />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default StatCard;
